import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchSettingsFailure,
  fetchSettingsSuccess,
  saveSettingsFailure,
  //
  saveSettingsSuccess,
} from "./actions";
import { FETCH_SETTINGS, SAVE_SETTINGS } from "./constants";

export function* fetchSettingsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/email-setting/${payload}`
    );
    yield put(fetchSettingsSuccess(data));
  } catch (e) {
    yield put(fetchSettingsFailure());
  }
}

export function* saveSettingsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/email-setting/edit/${payload.location_id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Email settings saved successfully!"));
      yield put(saveSettingsSuccess());
    }
  } catch (e) {
    yield put(saveSettingsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchSettingsFlow() {
  yield takeEvery(FETCH_SETTINGS, fetchSettingsSaga);
}
export function* saveSettingsFlow() {
  yield takeEvery(SAVE_SETTINGS, saveSettingsSaga);
}
export default function* SettingsSaga() {
  yield all([fetchSettingsFlow(), saveSettingsFlow()]);
}
